import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '@store/state';
import { getUserAuthorizations } from '@store/user-infos/user-infos.selector';
import { map } from 'rxjs';
import { HOME_PAGE } from 'src/app/app.routes';

export const authGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const store = inject(Store<State>);

    // Input 'requiredPermissions' in app.routes.ts
    const requiredPermissions: string[] = route.data?.['requiredPermissions'];

    return store.select(getUserAuthorizations).pipe(
        map((authorizations) => {
            if (requiredPermissions.some((permission) => authorizations.nofUserRoles.includes(permission))) {
                return true;
            }

            router.navigate([`/${HOME_PAGE}`]);
            return false;
        })
    );
};